import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import AnimatedTabButton from 'components/animations/AnimatedTabButton';
import { ScrollArea } from 'components/ui/scroll-area';
import AllNotifications from './AllNotifications';
import UnreadNotifications from './UnreadNotifications';

enum TABS {
  ALL = 'all',
  UNREAD = 'unread',
}

export default function NotificationPage() {
  const { t } = useTranslation();

  const [selectedTab, setSelectedTab] = useState<TABS>(TABS.UNREAD);

  const tabs = [
    { label: t('unread'), value: TABS.UNREAD },
    { label: t('all'), value: TABS.ALL },
  ];

  return (
    <div className='px-6 pt-4'>
      <div>
        {tabs.map(({ label, value }) => {
          return (
            <AnimatedTabButton
              key={value}
              onClick={() => setSelectedTab(value)}
              isSelected={value === selectedTab}
              label={label}
              className='w-28'
            />
          );
        })}
      </div>

      <ScrollArea className='h-fit lg:h-[calc(100vh-11rem)] pt-4'>
        {selectedTab === TABS.ALL && <AllNotifications />}
        {selectedTab === TABS.UNREAD && <UnreadNotifications />}
      </ScrollArea>
    </div>
  );
}
